module.exports = {
      id: "person-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#person-usage",
      toString: function () {
        return this.url;
      }
    }